<div class="header-bar">
  <div class="header-left"></div>
  <div class="header-center">
    {{ newGeofence ? "Create New Geofence" : "Geofence" }}
  </div>
  <div *ngIf="newGeofence" class="header-right">
    <button mat-button color="fiord" (click)="cancel()">Cancel</button>
    <button
      mat-button
      color="lightGreen"
      (click)="saveNewGeofence()"
      [disabled]="saveDisabled"
    >
      Save New Geofence
    </button>
  </div>
  <div *ngIf="!newGeofence" class="header-right">
    <!-- <button mat-button color="warn" (click)="deleteGeofence()">
      Delete Geofence
    </button> -->
    <button
      mat-button
      color="lightGreen"
      (click)="saveGeofenceUpdates()"
      [disabled]="saveDisabled"
    >
      Save Geofence Updates
    </button>
  </div>
</div>

<div class="geofence">
  <form [formGroup]="geofenceForm">
  <div class="containers">
    <div class="container geofence-map-container">
      <div class="container-header no-bottom-border">
        <div class="input-box">
          <input
            class="input"
            controlName="placeName"
            [formGroup]="geofenceForm!"
            ngx-google-places-autocomplete
            (onAddressChange)="onPlaceChange($event)"
            placeholder="🔍 Search for a location"
          />
        </div>
        <button mat-button (click)="setPanTool()">
          <svg-icon src="assets/svg/map-pan.svg"></svg-icon>
        </button>
        <button mat-button (click)="setPolyTool()">
          <svg-icon src="assets/svg/map-polygon.svg"></svg-icon>
        </button>
        <button mat-button (click)="setCircleTool()">
          <svg-icon src="assets/svg/map-circle.svg"></svg-icon>
        </button>
      </div>
      <div class="container-content">
        <google-map
          id="map"
          width="60vh"
          height="50vh"
          [options]="mapOptions"
        ></google-map>
      </div>
    </div>

    <div class="container geofence-details-container">
      <div class="container-header no-bottom-border">
        <div class="text">Geofence Settings</div>
      </div>
      <div class="container-content">
        <div class="container-row">
          <lhpe-input
            class="input"
            controlName="geofenceName"
            placeholder="Geofence Name"
            [formGroup]="geofenceForm!"
            [required]="true"
          >
          </lhpe-input>
        </div>

        <div class="container-row">
          <mat-form-field class="tag-chip-list">
            <mat-label>Tags</mat-label>
            <mat-chip-list #chipList aria-label="Tags">
              <mat-chip
                *ngFor="let tag of geofenceForm.controls.tags.value"
                (removed)="removeTag(tag)"
              >
                {{ tag }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip>
              <input
                placeholder="New tag..."
                [matChipInputFor]="chipList"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                [matChipInputAddOnBlur]="true"
                (matChipInputTokenEnd)="addTag($event)"
              />
            </mat-chip-list>
          </mat-form-field>
        </div>

        <div class="container-row">
          <lhpe-input
            class="input"
            controlName="geofenceTimeout"
            placeholder="Timeout (minutes)"
            [formGroup]="geofenceForm!"
            [required]="true"
          >
          </lhpe-input>
        </div>

        <div class="container-column">
          <label style="margin-bottom: 20px"
            >Accuracy Required: within
            {{ geofence?.min_accuracy }} meters</label
          >
          <div>
            <mat-slider
              thumbLabel
              min="10"
              max="1000"
              step="10"
              formControlName="minAccuracy"
            ></mat-slider>
          </div>
        </div>

        <div class="container-row" [formGroup]="geofenceForm">
          <mat-slide-toggle formControlName="onProperty"
            >Geofence Is Considered On-Property</mat-slide-toggle
          >
        </div>

        <div
          class="container-row"
          *ngIf="geofenceForm.controls.onProperty.value"
        >
          <mat-form-field
            appearance="fill"
            aria-placeholder="Select a Facility Floor"
            [formGroup]="geofenceForm"
          >
            <mat-label>Facility Floor*</mat-label>
            <mat-select [formControl]="facilityControl">
              <mat-optgroup
                *ngFor="let group of facilities"
                [label]="group.name"
              >
                <mat-option
                  *ngFor="let floor of group.floors"
                  [value]="floor.id"
                >
                  {{ floor.name }}
                </mat-option>
              </mat-optgroup>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="container-row" [formGroup]="geofenceForm">
          <mat-slide-toggle formControlName="competitor"
            >Geofence Is Competitor</mat-slide-toggle
          >
        </div>

        <div class="container-row">
          <lhpe-input
            class="input"
            controlName="foreignId"
            placeholder="Foreign ID"
            [formGroup]="geofenceForm!"
            [required]="false"
          >
          </lhpe-input>
        </div>

        <div class="container-row" *ngIf="currentCircle !== undefined">
          <div class="input-box">
            <mat-form-field>
              <mat-label>Radius (meters)</mat-label>
              <input
                matInput
                value="{{ circleRadius | number: '1.0-0' }}"
                disabled
              />
            </mat-form-field>
          </div>
        </div>

        <div class="container-row" *ngIf="!newGeofence">
          <div class="input-box">
            <mat-form-field>
              <mat-label>UID</mat-label>
              <input matInput value="{{ geofence?.uid }}" disabled />
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    class="containers"
    *ngIf="!newGeofence && intersectingGeofences!.length > 0"
  >
    <div class="container geofence-intersections-container">
      <div class="container-header no-bottom-border">
        <div class="text">Intersecting Geofences</div>
      </div>
      <div class="container-content">
        <table
          #geofencesTable
          mat-table
          [dataSource]="intersectionsDataSource"
          matSort
        >
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
            <td mat-cell *matCellDef="let element">
              {{ element.id }}
            </td>
          </ng-container>

          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Geofence Name
            </th>
            <td mat-cell *matCellDef="let element">{{ element.name }}</td>
          </ng-container>

          <ng-container matColumnDef="options">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element" class="options-cell">
              <button mat-button (click)="edit(element)" class="icon-btn">
                <svg-icon src="assets/svg/pencil.svg"></svg-icon>
              </button>
              <button mat-button (click)="delete(element)" class="icon-btn">
                <svg-icon
                  src="assets/svg/trashcan.svg"
                  [svgStyle]="{
                    'width.px': '15.25',
                    'height.px': '16.204'
                  }"
                  svgClass="lightBlue"
                ></svg-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="intersectionsColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: intersectionsColumns"></tr>
        </table>
      </div>
    </div>
  </div>
  </form>
</div>
